import { useState, useCallback, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import DashBoardSideBar from "../utils/dashboard-sidebar"
import { AuthStdFooter } from "../utils/auth-std-footer";
// import dashNarrator from '../assets/narrator_logo_a.png'
// import gearsAndBook from '../assets/gearsAndBook.svg'
import { ReactComponent as GearsAndBook } from '../assets/gearsAndBook.svg'

import DashBoardPages from '../components/dashBoardSubPage'

export default function Dashboard() {
  const location = useLocation();

  // Check if there's a menu selection in the location state
  const initialMenuSel = location.state?.menuSelection || "TEXT-LIBRARY";
  const [menuSel, setMenuSel] = useState(initialMenuSel);

  // Update menuSel when location state changes
  useEffect(() => {
    if (location.state?.menuSelection) {
      setMenuSel(location.state.menuSelection);
    }
  }, [location.state]);

  const menuSelection = useCallback((value) => {
    console.log('menuSelection', value)
    setMenuSel(value);
  }, []);
  const dashBoardHome = () => {
    return (
      <>
        <div className="std-pg-main-area std-pg-grey-background-color"   style={{ marginBottom: "70px" }}>
          <div className='dashBoardSidebar-inner' >
            <div className="dashSliderTitle">Dashboard</div>
            {/* <img className='dashboardHeadingIcon' src={gearsAndBook} alt="Narrator" width={200} /> */}
            <GearsAndBook className="dashboardHeadingIcon" />

            {DashBoardSideBar(menuSelection)}
          </div>

          <div className="dashBoardSubPage">


            {DashBoardPages(menuSel)}
          </div>
          <div className='dashBoardSidebar-ext'>

          </div>
        </div >
      </>
    )
  }
  return (<>{dashBoardHome()}</>)
}
